import { DatePipe } from "@angular/common";
import { FormControl, FormGroup, Validators } from "@angular/forms";
/*
export class Product {
    
    sno : number;
    productcategory :string;
    productcode :string;
    productname:string;
    uom :string;
    description :string;
    productimage :string;
    status :string;
    createdby :string;
    modifiedby :string;
    createdon : DatePipe;
    modifiedon : DatePipe;
}*/


export class ProductModel {
    
    productId : string;
    productName :string;
    categoryId :string;
    productCode : string;
    categoryCode : string;
    description:string;
    status :string;
    createTime :DatePipe;
    createBy :string;

    public static getFormGroup()
    {
        var form = new FormGroup({
            productId: new FormControl(null),
            productName: new FormControl('', Validators.required),
            categoryId : new FormControl(null),
            productCode : new FormControl(null),
            categoryCode : new FormControl(null),
            description: new FormControl(null),
            status : new FormControl(null),
            createTime : new FormControl(null),
            createBy : new FormControl(null)
        });

        return form;

    }

    public static populateForm(form, item : ProductModel) {
        form.setValue(item);
    }


    public static initializeFormGroup(form){
  
        form.setValue({
            productId : null,
            productName : null,
            categoryId : null,
            productCode : null,
            categoryCode : null,
            description: null,
            status : null,
            createBy : null,
            createTime : null,
           });

    }
 }

 export class ProductDetailModel {
    
    productId : string;
    productName :string;
    categoryId :string;
    productCode : string;
    categoryCode : string;
    categoryName :string;
    description:string;
    status :string;
    createTime :DatePipe;
    createBy :string;

    public static convertToProductModel(item : ProductDetailModel)
    {
        var data = new ProductModel();
        data.productId = item.productId;
        data.productName = item.productName;
        data.categoryId = item.categoryId;
        data.productCode = item.productCode;
        data.categoryCode = item.categoryCode;
        data.description = item.description;
        data.status = item.status;
        data.createTime = item.createTime;
        data.createBy = item.createBy;
        
        return data;
    }
 }
